import React from 'react';
import { useSelector } from 'react-redux';
import { BaseMultiSelect } from 'shared/inputs';
import { getFileTypes } from 'src/slices/fileTypes';

const DocumentTypesControl = (props) => {
  const documentTypes = useSelector(getFileTypes);
  return (
    <div className="control-wrapper">
      <BaseMultiSelect
        keysOnly
        id="documentTypes"
        data={documentTypes}
        textField='name'
        dataItemKey='id'
        {...props}
      />
    </div>
  );
};

export default DocumentTypesControl;
